export default __webpack_public_path__ + "static/media/training-icon.297f82bf.svg";